export const headerMenus = [
  {
    active: true,
    name: 'Home',
    url: '/'
  },
  {
    active: false,
    name: 'Wagers',
    url: '/wagers'
  },
  {
    active: false,
    name: 'Results',
    url: '/results'
  },
  // {
  //   active: false,
  //   name: 'Upcoming',
  //   url: '/upcoming'
  // },
  {
    active: false,
    name: 'How to Play',
    url: '/how-to-play'
  },
  {
    active: false,
    isCart: true
  }
];

// Home, Wagers, Results, Upcoming, How to Play
